/**
 * @desc Services entrance
 * @author Jooger <iamjooger@gmail.com>
 * @date 1 Dec 2017
 */

'use strict'

export { default as api } from './api'



// WEBPACK FOOTER //
// ./src/services/index.js